import * as React from 'react';

class TrashSvg extends React.Component<Svg.IProps, Svg.IState> {
  static defaultProps: Svg.IProps = { className: '' };

  render() {
    const { className, ...rest } = this.props;

    return (
      <svg
        viewBox="0 0 14 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`svg-icon trash-svg ${className || 'm-3'}`}
        {...rest}
      >
        <path
          d="M3.875 15.0001H5.125V7.50015H3.875V15.0001ZM3.45625 3.12515L10.85 1.87515C10.9321 1.86161 11.0107 1.83203 11.0813 1.78811C11.152 1.74419 11.2133 1.68678 11.2617 1.61917C11.3102 1.55156 11.3449 1.47506 11.3638 1.39405C11.3827 1.31304 11.3854 1.2291 11.3719 1.14702C11.3583 1.06495 11.3288 0.986343 11.2848 0.915697C11.2409 0.845052 11.1835 0.783749 11.1159 0.735288C11.0483 0.686827 10.9718 0.652158 10.8908 0.633261C10.8098 0.614363 10.7258 0.611607 10.6438 0.62515L3.25 1.87515C3.08424 1.9025 2.93613 1.99458 2.83826 2.13113C2.74039 2.26768 2.70078 2.43751 2.72813 2.60327C2.75548 2.76904 2.84755 2.91714 2.9841 3.01501C3.12065 3.11288 3.29049 3.1525 3.45625 3.12515ZM8.875 15.0001H10.125V7.50015H8.875V15.0001ZM6.375 15.0001H7.625V7.50015H6.375V15.0001ZM13.0688 4.5564C13.0104 4.49847 12.9411 4.45265 12.8649 4.42154C12.7888 4.39044 12.7073 4.37467 12.625 4.37515H1.375C1.20924 4.37515 1.05027 4.441 0.933058 4.55821C0.815848 4.67542 0.75 4.83439 0.75 5.00015V17.5001C0.75 17.6659 0.815848 17.8249 0.933058 17.9421C1.05027 18.0593 1.20924 18.1251 1.375 18.1251H12.625C12.7908 18.1251 12.9497 18.0593 13.0669 17.9421C13.1842 17.8249 13.25 17.6659 13.25 17.5001V5.00015C13.2505 4.9179 13.2347 4.83636 13.2036 4.76021C13.1725 4.68406 13.1267 4.6148 13.0688 4.5564ZM2 16.8751V5.62515H12V16.8751H2Z"
          fill="#EA1C0A"
        />
      </svg>
    );
  }
}

export default TrashSvg;
